<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="slu-dashboard-status-tags"
            :items="tableData"
            :fields="tagFields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-slu-status-tag"
                    v-b-modal="'add-slu-status-tag-modal'"
                    type="button"
                    label="create-new-slu-status-tag"
                    variant="primary">
                    {{ $t('slu_dashboard.add_option') }}
                </b-button>
            </template>

            <template #cell(color)="data">
                <div
                    class="color-icon"
                    :style="cssVars(data.item.color)">
                    <i
                        class="fas fa-circle"
                        v-b-tooltip.hover
                        :title="$t('slu_dashboard.color_code', { color: data.item.color })"></i>
                </div>
            </template>
            <template v-slot:cell(action)="data">
                <div class="management-actions">
                    <b-button
                        class="btn-edit btn-edit-slu-cohort btn-"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.edit')"
                        @click="editSluStatusTag(data.item)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-slu-cohort"
                        v-if="!data.item.undeletable"
                        variant="danger-icon-only"
                        @click="deleteStatusTag(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-add-slu-status-tag-modal-component
            :stc-in="sluSchoolSettings.stc_sync"
            @updateStatusTags="addStatusTag($event)"
            ref="add-slu-status-tag-modal">
        </design-2021-add-slu-status-tag-modal-component>
        <design-2021-update-slu-status-tag-modal-component
            :stc-in="sluSchoolSettings.stc_sync"
            @updateStatusTags="updateStatusTags($event)"
            ref="edit-slu-status-tag-modal">
        </design-2021-update-slu-status-tag-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-slu-dashboard-status-tags-tab-component',
    props: ['sluStatusTagsIn', 'sluSchoolSettingsIn'],
    data() {
        return {
            sluStatusTags: this.sluStatusTagsIn,
            sluSchoolSettings: this.sluSchoolSettingsIn,
        };
    },
    computed: {
        tagFields() {
            let fields = [
                {
                    key: 'color',
                    label: this.$t('common.colour'),
                },
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'finished',
                    label: this.$t('slu_dashboard.finished'),
                },
            ];
            if (this.sluSchoolSettings.stc_sync) {
                fields.push({
                    key: 'stc_value',
                    label: this.$t('slu_dashboard.value'),
                });
            }
            fields.push([
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ]);
            return fields;
        },
        tableData() {
            let data = [];

            data = data.concat(this.sluStatusTags);
            data.push({
                id: null,
                color: this.sluSchoolSettings.color_unfinished ? this.sluSchoolSettings.color_unfinished : '#999999',
                name: this.sluSchoolSettings.name_unfinished
                    ? this.sluSchoolSettings.name_unfinished
                    : this.$t('slu_dashboard.unfinished'),
                finished: 0,
                undeletable: true,
            });

            const finishedTagsOnly = data.filter((tag) => tag.finished);
            if (!finishedTagsOnly.length) {
                data.push({
                    id: 0,
                    color: '#66BB88',
                    name: this.$t('slu_dashboard.finished'),
                    finished: 1,
                    undeletable: true,
                });
            }

            return data;
        },
    },
    methods: {
        addStatusTag(tag) {
            this.sluStatusTags.push(tag);
        },
        editSluStatusTag(tag) {
            this.$refs['edit-slu-status-tag-modal'].show(tag);
        },
        updateStatusTags(tag) {
            this.sluStatusTags = this.sluStatusTags.map((sluStatusTag) => {
                if (sluStatusTag.id === tag.id) {
                    const newTag = { ...sluStatusTag, ...tag };
                    return newTag;
                } else {
                    return sluStatusTag;
                }
            });
            if (tag.id === null) {
                this.sluSchoolSettings = tag.response;
            }
        },
        deleteStatusTag(tagId) {
            this.alert
                .confirm(
                    this.$t('slu_dashboard.delete_approval_option'),
                    this.$t('slu_dashboard.are_you_sure_you_want_to_delete_this_approval_option'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios.delete(this.routes.sluStatusTagsDelete(tagId)).then(
                        (response) => {
                            this.sluStatusTags = this.sluStatusTags.filter((item) => item.id !== tagId);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        cssVars(color) {
            return {
                '--category-color': color,
            };
        },
    },
};
</script>

<style scoped lang="scss">
.color-icon {
    font-size: $base-font-size;

    i {
        color: var(--category-color);
    }
}
</style>
